import { LabelValue } from "settings/support/utils/tickets";

export const productData: LabelValue[] = [
	{ label: "CTX Reflector", value: "ctx-r" },
	{ label: "CTX Reflector V2", value: "ctx-r" },
	{ label: "Kontrol Edge", value: "ke" },
	{ label: "Insight", value: "insight" },
];

export const countryCodes: LabelValue[] = [
	{ label: "United States (+1)", value: "+1" },
	{ label: "Mexico (+52)", value: "+52" },
	{ label: "Canada (+1)", value: "+1" },
];

export const productDataIncident: LabelValue[] = [
  { label: "CTX Reflector", value: "ctx-r" },
  { label: "CTX Reflector V2", value: "ctx-r" },
  { label: "Dashboard", value: "dashboard" },
  { label: "Kontrol Edge", value: "ke" },
  { label: "Insight", value: "insight" },
];